import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { TreeView, TreeItem } from "@material-ui/lab";
import { ExpandMore, ChevronRight} from "@material-ui/icons";
import { webRoot } from "../../../../../utils/urlHelpers";
import { getNodesToExpand } from "./orgTreeUtilities";
import { Permissions } from '../../../../../data/Permissions';

const useStyles =  makeStyles(theme => ({
    root: {
        flexGrow: 1,
        maxWidth: 400,
    },
    treeItem: {
        padding: theme.spacing(.5, 0)
    }
}));

export default function OrgTreeView({ orgTree, orgId, userPermissions }) {
    const classes = useStyles();
    const [selected, setSelected] = useState(orgId);
    
    const viewEAdminCustIdRoles = [Permissions.globalAdmin, Permissions.globalEditor, Permissions.globalSupport];
    const showEAdminCustId = !!viewEAdminCustIdRoles.filter(role => userPermissions[role]).length;
    
    let nodesToExpand = [];
    getNodesToExpand(orgTree, orgId, nodesToExpand);
    
    const handleSelect = (event, id) => {
        event.preventDefault();
        location.href = webRoot() + id;
        setSelected(id);
    };
    
	const sortNodes = (nodes) => nodes.sort((a, b) => a.name.localeCompare(b.name));

	const renderTree = (nodes) => {
        const sortedChildren = sortNodes(nodes.children);

        return (
            <TreeItem
                onLabelClick={e => handleSelect(e, nodes.id)}
                key={nodes.id}
                nodeId={nodes.id.toString()}
                label={nodes.name}
				title={showEAdminCustId ? nodes.eAdminCustId : null}
                className={classes.treeItem}
            >
                {Array.isArray(sortedChildren) ? sortedChildren.map((node) => renderTree(node)) : null}
            </TreeItem>
        );
    }

    return (
        <TreeView
            className={classes.root}
            defaultCollapseIcon={<ExpandMore />}
            defaultExpandIcon={<ChevronRight />}
            defaultExpanded={nodesToExpand}
            selected={selected.toString()}
        >
            {orgTree.map(orgNode => renderTree(orgNode))}
        </TreeView>
    );
}
